import { UserPlus } from 'lucide-react';

import { PageHeader } from '../../../components/ui';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import { WhitelistEmailsTab } from './WhitelistEmailsTab';
import { WhitelistInterestTab } from './WhitelistInterestTab';
import { WhitelistSettingsCard } from './WhitelistSettingsCard';

export default function WhitelistManagementPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Whitelist & Convites"
        subtitle="Controle o acesso ao piloto monitorado e acompanhe o interesse de novos usuários."
        icon={<UserPlus />}
      />

      <WhitelistSettingsCard />

      <Tabs defaultValue="emails">
        <TabsList>
          <TabsTrigger value="emails">Emails permitidos</TabsTrigger>
          <TabsTrigger value="interest">Interessados</TabsTrigger>
        </TabsList>
        <TabsContent value="emails" className="mt-6">
          <WhitelistEmailsTab />
        </TabsContent>
        <TabsContent value="interest" className="mt-6">
          <WhitelistInterestTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
